import {Component, Input, OnInit} from '@angular/core';
import {LoyaltyProgramInfoComponent} from "../modals/loyalty-program-info/loyalty-program-info.component";
import {ModalController} from "@ionic/angular";
import {InfoComponentModal} from "../modals/info/info.component";

@Component({
    selector: 'app-semi-header',
    templateUrl: './semi-header.component.html',
    styleUrls: ['./semi-header.component.scss'],
})
export class SemiHeaderComponent implements OnInit {

    @Input() title: string = ''
    @Input() info: string = ''
    @Input() avgProgress: number = 0;
    @Input() showProgress: boolean = false;
    @Input() showAchievementInfo: boolean = false;
    @Input() showCountrics: boolean = false;
    @Input() countrics: number = 0;
    @Input() withShadow: boolean = false;
    @Input() backPath: string|undefined = undefined;

    constructor(private modalCtrl: ModalController) {
    }

    ngOnInit() {
    }

    async openModal(type:string) {
        const modal = await this.modalCtrl.create({
            component: InfoComponentModal,
            cssClass: 'auto-height',
            componentProps: {
                type: type,
                text: this.info
            }


        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

}
